export default "__VITE_ASSET__CjYlzb7d__"